module.exports = __webpack_public_path__ + "img/04.b274d0eb.jpg";